import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";
import TryItButton from "../../../TryItButton";
import OutputBox from "../../../OutputBox";

export default function JS_NestedIf() {
  return (
    <div className="tutorial-container read-only">
      <h1 className="tutorial-title">🏗️ JavaScript Nested if Statement</h1>

      <p className="tutorial-intro">
        A <code className="highlight_code">nested if</code> places one{" "}
        <code>if</code> statement inside another. It’s perfect when one
        condition must be true before checking another — such as layered login
        or permission systems at Edu-Tech Master Academy.
      </p>

      <div
        className="Key_point_container"
        style={{ background: "linear-gradient(135deg, #ffedd5, #fed7aa)" }}
      >
        <h2 style={{ color: "#9a3412" }}>🔑 Key Points</h2>
        <ul className="tutorial-list-points">
          <li>Used for multi-level condition checks.</li>
          <li>Helps manage authentication or permission logic.</li>
          <li>Each nested block runs only if the parent condition is true.</li>
        </ul>
      </div>

      {/* Example 1 */}
      <div className="tutorial-section">
        <h2 className="section-title">1️⃣ Login and Role Check</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let isLoggedIn = true;
let isAdmin = true;

if (isLoggedIn) {
  if (isAdmin) {
    console.log("Welcome Admin to Edu-Tech Master Academy Dashboard!");
  }
}`}
          />
          <TryItButton
            code={`let isLoggedIn = true;
let isAdmin = true;

if (isLoggedIn) {
  if (isAdmin) {
    console.log("Welcome Admin to Edu-Tech Master Academy Dashboard!");
  }
}`}
          />
        </div>
        <OutputBox>
          <pre>Welcome Admin to Edu-Tech Master Academy Dashboard!</pre>
        </OutputBox>
      </div>

      {/* Example 2 */}
      <div className="tutorial-section">
        <h2 className="section-title">2️⃣ Student Performance Check</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let attendance = 80;
let marks = 70;

if (attendance >= 75) {
  if (marks >= 60) {
    console.log("Student eligible for certificate at Edu-Tech Master Academy.");
  }
}`}
          />
          <TryItButton
            code={`let attendance = 80;
let marks = 70;

if (attendance >= 75) {
  if (marks >= 60) {
    console.log("Student eligible for certificate at Edu-Tech Master Academy.");
  }
}`}
          />
        </div>
        <OutputBox>
          <pre>
            Student eligible for certificate at Edu-Tech Master Academy.
          </pre>
        </OutputBox>
      </div>

      {/* Example 3 */}
      <div className="tutorial-section">
        <h2 className="section-title">3️⃣ Device and Access Check</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let isLoggedIn = true;
let device = "mobile";

if (isLoggedIn) {
  if (device === "mobile") {
    console.log("Mobile access granted to Edu-Tech Master Academy.");
  } else {
    console.log("Desktop access granted.");
  }
}`}
          />
          <TryItButton
            code={`let isLoggedIn = true;
let device = "mobile";

if (isLoggedIn) {
  if (device === "mobile") {
    console.log("Mobile access granted to Edu-Tech Master Academy.");
  } else {
    console.log("Desktop access granted.");
  }
}`}
          />
        </div>
        <OutputBox>
          <pre>Mobile access granted to Edu-Tech Master Academy.</pre>
        </OutputBox>
      </div>
      {/* Next Steps */}
      <div
        style={{
          background: "linear-gradient(135deg, #fed7aa, #fdba74)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2 style={{ color: "#9a3412" }}>🚀 Next Steps</h2>
        <ul className="tutorial-list-points">
          <li>
            Combine nested <code className="highlight_code">if</code> with{" "}
            <code className="highlight_code">else</code> blocks.
          </li>
          <li>Use nested if for multi-level access or role-based logic.</li>
          <li>
            Explore <code className="highlight_code">if...else if...else</code>{" "}
            for sequential checks.
          </li>
        </ul>
      </div>
    </div>
  );
}
